import { Auth } from "@aws-amplify/auth";
import axios, { AxiosPromise, AxiosRequestConfig } from "axios";

import { envConfig } from "config/env";

export const apiClient = axios.create({
	baseURL: envConfig.API_URL,
	params: {},
	headers: {},
});

const cognitoInterceptor = async (request: AxiosRequestConfig) => {
	const session = await Auth.currentSession().catch(() => undefined);
	if (request.headers && session) request.headers["Authorization"] = `Bearer ${session.getIdToken().getJwtToken()}`;
	return request;
};

console.log("Adding default cognito interceptor");
apiClient.interceptors.request.use(cognitoInterceptor);

export type CustomAxiosRequest<I, O> = (args: I) => AxiosPromise<O>;
